import cn from 'classnames';
import React, { FC, ReactNode, useRef } from 'react';

import { useTooltip } from '@.hooks';

import { isBrandArchived } from '../../model/isBrandArchived';
import S from './BrandArchivedContainer.module.scss';

type BrandObject = {
    deleted_at?: number | null;
};

interface BrandArchivedContainerProps {
    brand: BrandObject | null;
    className?: string;
    children?: ReactNode;
}

export const BrandArchivedContainer: FC<BrandArchivedContainerProps> = ({ className, brand, children }) => {
    const [tooltip, setTooltip, setOpen] = useTooltip({});

    const rootRef = useRef<HTMLDivElement | null>(null);

    if (brand && isBrandArchived(brand)) {
        const showTooltip = () => {
            const rootElement = rootRef.current;

            if (!rootElement) {
                return;
            }

            const rect = rootElement.getBoundingClientRect();

            const LEFT_OFFSET = 10;

            setTooltip({
                content: 'Brand is archived',
                coordinates: { x: rect.left + LEFT_OFFSET, y: rect.top },
                offsetX: rect.width,
                open: true,
            });
        };

        const hideTooltip = () => setOpen(false);

        return (
            <div ref={rootRef} className={cn(S.root, className)} onMouseEnter={showTooltip} onMouseLeave={hideTooltip}>
                {children}
                {tooltip}
            </div>
        );
    }

    return <>{children}</>;
};
